import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import app from 'flarum/common/app';

// Phase 1 i18n — t() flatten array, 坑 B 沉淀
function t(key) {
  const result = app.translator.trans(key);
  return Array.isArray(result) ? result.join('') : result;
}
function tRich(key, params) {
  return app.translator.trans(key, params || {});
}

// v0.4.2 fix: view() → content() + title() (跟 SeedreamDetailModal/EquipmentSelectModal/AvatarModal 一致)
// v0.4.0 round 6 fix 错把 content() 改成 view() 是本轮 bug 根因:
// Modal 父类 view() 期望子组件提供 title() + content() 两个 hook, 子组件没实现 → 父类 view 走 error 分支
//   → element 是 null → animateShow 在 null 上 addEventListener → TypeError 报错
// 同时 modal 样式跟其他 modal 不一样 (= 没走 Modal 父类 wrapper = 没 title header + 没 footer)
// 跟 3 PASS modal 完全一致后 = 修复 element null + modal 样式
export default class PresetModelDetailModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.model = null;
    this.loading = true;
    this.loadModel();
  }
  className() {
    return 'Modal Modal--large PresetModelDetailModal';
  }
  title() {
    return t('ziven-dress-up.forum.preset_model_detail_modal.title');
  }

  // 用普通方法 + Promise 链 (跟 round 2 修复后一样 = 避免 async generator hoist)
  loadModel() {
    const self = this;
    return app.request({
      method: 'GET',
      // v0.4.0 Phase 2 批 2C-1 round 7 fix: 补 /ziven/ namespace (32 案例 lesson)
      // app.forum.attribute('apiUrl') 返回 /api (无 namespace), extend.php 路由 = /ziven/seedream/preset-models/{id}
      // 改前 /api/seedream/preset-models/{id} → 404; 改后 /api/ziven/seedream/preset-models/{id} → 200
      url: app.forum.attribute('apiUrl') + '/ziven/seedream/preset-models/' + this.attrs.modelId
    }).then(function (response) {
      if (response && response.success && response.data) {
        self.model = response.data;
      } else {
        console.warn('Failed to load preset model:', response);
      }
    }).catch(function (error) {
      console.error('Failed to load preset model:', error);
    }).then(function () {
      self.loading = false;
      m.redraw();
    });
  }
  content() {
    if (this.loading) {
      return m('div', {
        class: 'Modal-body'
      }, m('div', {
        class: 'preset-detail-loading'
      }, LoadingIndicator.component({
        size: 'large'
      }), m('p', t('ziven-dress-up.forum.common.loading'))));
    }
    if (!this.model) {
      return m('div', {
        class: 'Modal-body'
      }, m('div', {
        class: 'preset-detail-error'
      }, m('i', {
        class: 'fas fa-exclamation-circle'
      }), m('p', t('ziven-dress-up.forum.preset_model_detail_modal.load_error')), Button.component({
        className: 'btn-glass',
        onclick: () => this.loadModel()
      }, t('ziven-dress-up.forum.common.retry'))));
    }
    return m('div', {
      class: 'Modal-body'
    }, m('div', {
      class: 'preset-detail-content'
    }, m('div', {
      class: 'preset-detail-image'
    }, m('img', {
      src: this.model.image_url || '/assets/avatars/placeholder.png'
    })), m('div', {
      class: 'preset-detail-info'
    }, m('h3', this.model.name), m('div', {
      class: 'meta-list'
    }, m('div', {
      class: 'meta-item'
    }, t('ziven-dress-up.forum.preset_model_detail_modal.gender_label'), this.formatGender(this.model.gender)), m('div', {
      class: 'meta-item'
    }, t('ziven-dress-up.forum.preset_model_detail_modal.category_label'), this.model.category || t('ziven-dress-up.forum.preset_model_detail_modal.uncategorized')), m('div', {
      class: 'meta-item'
    }, t('ziven-dress-up.forum.preset_model_detail_modal.description_label'), this.model.description || t('ziven-dress-up.forum.preset_model_detail_modal.no_description'))), m('div', {
      class: 'equipment-preview-section'
    }, m('h4', t('ziven-dress-up.forum.preset_model_detail_modal.equipment_preview')), m('div', {
      class: 'equipment-preview-empty'
    }, m('i', {
      class: 'fas fa-tshirt'
    }), m('p', t('ziven-dress-up.forum.preset_model_detail_modal.no_equipment')))))), m('div', {
      class: 'PresetModelDetailModal-footer'
    }, Button.component({
      className: 'btn-amber',
      onclick: () => {
        if (this.attrs.onSelect) this.attrs.onSelect(this.model);
        app.modal.close();
      }
    }, t('ziven-dress-up.forum.preset_model_detail_modal.confirm'))));
  }
  formatGender(g) {
    const map = {
      0: t('ziven-dress-up.forum.preset_model_detail_modal.unknown'),
      1: t('ziven-dress-up.forum.preset_model_detail_modal.gender_male'),
      2: t('ziven-dress-up.forum.preset_model_detail_modal.gender_female'),
      male: t('ziven-dress-up.forum.preset_model_detail_modal.gender_male'),
      female: t('ziven-dress-up.forum.preset_model_detail_modal.gender_female')
    };
    return map[g] || t('ziven-dress-up.forum.preset_model_detail_modal.unknown');
  }
}
flarum.reg.add('ziiven-dress-up', 'forum/components/PresetModelDetailModal', PresetModelDetailModal);